const { gameStepsUiTexts, gamePhasesUiTexts, generalUiTexts } = require('./../ui-texts');

const gameSteps = [
	/* PHASE 1 */
	{
		id: 'welcome', 
		index: 0, 
		phase: 1,
		sectionId: 1,
		title: gameStepsUiTexts.introduction, 
		subtitle: gameStepsUiTexts.welcome, 
		infoPopup: null,
		page: 'welcome'
	},
	{
		id: 'crew-select', 
		index: 1, 
		phase: 1,
		sectionId: 1,
		title: gameStepsUiTexts.crew, 
		subtitle: gameStepsUiTexts.selectCrew, 
		infoPopup: {
			title: generalUiTexts.crewInfo,
			contentId: 'crewInfoText',
			isScenarioSpecific: false,
			autoShow: true
		},
		page: 'crew-select'
	},
	{
		id: 'crew-feedback', 
		index: 2, 
		phase: 1,
		sectionId: 1,
		title: gameStepsUiTexts.crew, 
		subtitle: gameStepsUiTexts.selectCrew, 
		infoPopup: null,
		page: 'crew-feedback'
	},
	// {
	// 	id: 'crew-reflection', 
	// 	index: 3, 
	// 	phase: 1,
	// 	sectionId: 2,
	// 	title: gamePhasesUiTexts.selectCrew, 
	// 	subtitle: gameStepsUiTexts.reflection, 
	// 	infoPopup: null,
	// 	page: 'crew-reflection'
	// },
	// {
	// 	id: 'crew-reflection-result', 
	// 	index: 4, 
	// 	phase: 1,
	// 	sectionId: 3,
	// 	title: gamePhasesUiTexts.selectCrew, 
	// 	subtitle: gameStepsUiTexts.results, 
	// 	infoPopup: null,
	// 	page: 'crew-reflection-result',
	// 	backBtn: true
	// },
	/* PHASE 2 */
	{
		id: 'check-in', 
		index: 5, 
		phase: 2,
		sectionId: 1,
		title: gamePhasesUiTexts.checkIn, 
		subtitle: null, 
		infoPopup: {
			title: generalUiTexts.briefing,
			contentId: '',
			isScenarioSpecific: true,
			autoShow: true,
		},
		page: 'game-board'
	},
	/* PHASE 3 */
	{
		id: 'check-in-reflection',
		index: 6,
		phase: 3,
		sectionId: 1,
		title: gamePhasesUiTexts.reflection,
		subtitle: null,
		infoPopup: null,		
		page: 'reflection'
	},
	{
		id: 'check-in-reflection-result',
		index: 7,
		phase: 3,
		sectionId: 2,
		title: gamePhasesUiTexts.reflection,
		subtitle: gamePhasesUiTexts.results,
		infoPopup: null,		
		backBtn: true,
		page: 'reflection-result'
	},
	/* PHASE 4 */
	{
		id: 'scramble', 
		index: 8, 
		phase: 4,
		sectionId: 1,
		title: gamePhasesUiTexts.scramble, 
		subtitle: null, 
		infoPopup: {
			title: generalUiTexts.briefing,
			contentId: '',
			isScenarioSpecific: true,
			autoShow: true
		},
		page: 'game-board'
	},
	/* PHASE 5 */
	{
		id: 'outbound', 
		index: 9, 
		phase: 5,
		sectionId: 1,
		title: gamePhasesUiTexts.outbound, 
		subtitle: null, 
		infoPopup: {
			title: generalUiTexts.briefing,
			contentId: '',
			isScenarioSpecific: true,
			autoShow: true
		},
		page: 'game-board'
	},
	/* PHASE 6 */
	{
		id: 'on-site', 
		index: 10, 
		phase: 6,
		sectionId: 1,
		title: gamePhasesUiTexts.onSite, 
		subtitle: null, 
		infoPopup: {
			title: generalUiTexts.briefing,
			contentId: '',
			isScenarioSpecific: true,
			autoShow: true
		},
		page: 'game-board'
	},
	/* PHASE 7 */
	{
		id: 'transport-hospital', 
		index: 11, 
		phase: 7,
		sectionId: 1,
		title: gamePhasesUiTexts.transportHospital, 
		subtitle: null, 
		infoPopup: {
			title: generalUiTexts.briefing,
			contentId: '',
			isScenarioSpecific: true,
			autoShow: true
		},
		page: 'game-board'
	},

	/* PHASE 8 */
	{
		id: 'final-reflection',
		index: 12,
		phase: 8,
		sectionId: 1,
		title: gamePhasesUiTexts.finalReflection,
		subtitle: null,
		infoPopup: null,
		page: 'reflection'
	},
	{
		id: 'final-reflection-result',
		index: 13,
		phase: 8,
		sectionId: 2,
		title: gamePhasesUiTexts.finalReflection,
		subtitle: gamePhasesUiTexts.results,
		infoPopup: null,
		backBtn: true,
		page: 'reflection-result'
	},

	/* PHASE 9 */
	{
		id: 'exercise',
		index: 14,
		phase: 9,
		sectionId: 1,
		title: gamePhasesUiTexts.debrief,
		subtitle: null,
		infoPopup: {
			title: generalUiTexts.briefing,
			contentId: '',
			isScenarioSpecific: true,
			autoShow: false
		},
		page: 'exercise'
	},
	{
		id: 'exercise-result',
		index: 15,
		phase: 9,
		sectionId: 2,
		title: gamePhasesUiTexts.debrief,
		subtitle: gamePhasesUiTexts.results,
		infoPopup: {
			title: generalUiTexts.briefing,
			contentId: '',
			isScenarioSpecific: true,
			autoShow: false
		},
		backBtn: true,
		page: 'exercise-result'
	},


	/* PHASE 10 */
	{
		id: 'final-debrief',
		index: 16,
		phase: 10,
		sectionId: 1,
		title: gamePhasesUiTexts.debrief,
		subtitle: null,
		infoPopup: null,
		page: 'reflection'
	},
	{
		id: 'final-debrief-result',
		index: 17,
		phase: 10,
		sectionId: 2,
		title: gamePhasesUiTexts.reflection,
		subtitle: gamePhasesUiTexts.results,
		infoPopup: null,
		backBtn: true,
		page: 'reflection-result'
	},
	
	/* PHASE 11 */
	{
		id: 'final-result',
		index: 18, 
		phase: 11,
		sectionId: 1,
		title: gamePhasesUiTexts.results, 
		subtitle: null, 
		infoPopup: null,
		showMedal: true,
		page: 'game-result',
	},
	/* PHASE 12 */
	{
		id: 'gameover', 
		index: 19, 
		phase: 12,
		sectionId: 1,
		title: gamePhasesUiTexts.gameover, 
		infoPopup: null,
		page: 'gameover'
	}
];

module.exports = {gameSteps};